import React, { Component } from "react";

import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import { withNamespaces } from "react-i18next";

import MobileSubHeader from "../../../components/PageHeader/MobileSubHeader";
import StringInput from "../../../components/Input/StringInput/StringInput"

export class SecurityAns extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  stepSecurityCheck = (props) => {
    const { t } = this.props;
      
    return (
      <form 
        className="forms-col needs-validation form-security-ans mt-4"
        id="setSecurityQuestionForm"
        name="setSecurityQuestionForm"
        noValidate
        onSubmit={props.status === "insert" ? (e) => props.setSecurityQuestionHandler(e) : (e) => props.updateSecurityQuestionHandler(e)}
        method="post"
      >
        <div className="pd-form-m-col">
          <div className="input-group-col">
            {props.questions &&
              props.questions.map((item, index) => (
                
                <div className={`py-2 border-bottom ${index === 0 ? "pt-0" : ""}`} key={index}>
                  <label className="col-form-label p-0 m-0">
                  {t("validation.question")} {item.id}: {item.question}
                  </label>
                  <div className="verificate-m-input">
                    <StringInput
                      // className={`${this.props.errorMsg.mobile_no && "was-validated is-invalid"}`}
                      className="form-control w-100"
                      type="text"
                      placeholder={t("validation.insert-security-ans")}
                      name="securityAns"
                      defaultValue=""
                      value={props["checkAns" + item.id]}
                      onChange={(e) => props.updateSecurityCheckAns(e, item.id)}
                      // minLength={contact_no_min_limits}
                      // maxLength={contact_no_max_limits}
                      // minLengthMessage={t("validation.minLength", { 0: contact_no_min_limits })}
                      // maxLengthMessage={t("validation.maxLength", { 0: contact_no_max_limits })}
                      required
                      requiredMessage={t("validation.required")}
                      // errorMsg={this.props.errorMsg.mobile_no || ""}
                      // formError={this.props.formError}
                    />
                  </div>
                </div>
              ))}
          </div>
        </div>
        <p className="notice-desc px-3">
        {t("validation.tips-1")}
        </p>
        <button className="btn btn-gradient-blue mx-3" type="submit" form="setSecurityQuestionForm">
        {t("global.save")}
        </button>
      </form>
    );
  };

  stepSecuritySetting = (props) => {
    const { t } = this.props;
    return (
      <>
        <form className="forms-col needs-validation form-security-ans" onSubmit={props.updateSecuritySetting}>
          <div className="pd-form-m-col">
            <div className="input-group-col">
              {props.newSecuritySetting &&
                props.newSecuritySetting.map((item, index) => (
                  <div className={`py-2 border-bottom ${index === 0 ? "pt-0" : ""}`} key={index}>
                    <div className="input-group left has-validation mb-2">
                      <p className="my-auto w-25 text-dark">{t("validation.question")} {item.id}: </p>
                      <StringInput
                        // className={`${this.props.errorMsg.mobile_no && "was-validated is-invalid"}`}
                        className="form-control"
                        type="text"
                        placeholder={t("validation.insert-security-ans")}
                        name="securityQues"
                        defaultValue=""
                        value={props["newQuestion" + item.id]}
                        onChange={(e) => props.updateNewSecurityQuestion(e, item.id)}
                        // minLength={contact_no_min_limits}
                        // maxLength={contact_no_max_limits}
                        // minLengthMessage={t("validation.minLength", { 0: contact_no_min_limits })}
                        // maxLengthMessage={t("validation.maxLength", { 0: contact_no_max_limits })}
                        required
                        // requiredMessage={t("validation.required")}
                        // errorMsg={this.props.errorMsg.mobile_no || ""}
                        // formError={this.props.formError}
                      />
                    </div>
                    <div className="input-group left has-validation mb-2">
                      <p className="my-auto w-25 text-dark">{t("validation.answer")}: </p>
                      <StringInput
                        // className={`${this.props.errorMsg.mobile_no && "was-validated is-invalid"}`}
                        className="form-control"
                        type="text"
                        placeholder={t("validation.insert-security-ans")}
                        name="securityAns"
                        defaultValue=""
                        value={props["newAns" + item.id]}
                        onChange={(e) => props.updateNewSecurityAns(e, item.id)}
                        // minLength={contact_no_min_limits}
                        // maxLength={contact_no_max_limits}
                        // minLengthMessage={t("validation.minLength", { 0: contact_no_min_limits })}
                        // maxLengthMessage={t("validation.maxLength", { 0: contact_no_max_limits })}
                        required
                        // requiredMessage={t("validation.required")}
                        // errorMsg={this.props.errorMsg.mobile_no || ""}
                        // formError={this.props.formError}
                      />
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <div className="px-3" style={{ marginTop: "-1rem" }}>
            <div className="text-danger d-flex align-items-start my-2">
              <span style={{ width: "0.75rem", height: "0.75rem" }}>
                <Icon className="me-1" icon="akar-icons:circle-alert-fill" />
              </span>
              <span>
              {t("validation.length-20")}
              </span>
            </div>
            <p className="notice-desc">
            {t("validation.tips-2")}
            </p>
          </div>
          <button className="btn btn-gradient-blue mx-3 mb-3" type="submit" disabled={false}>
          {t("global.next")}
          </button>
        </form>
      </>
    );
  };

  stepSecurityConfirmation = (props) => {
    const { t } = this.props;
    return (
      <form className="forms-col needs-validation form-security-ans">
        <div className="pd-form-m-col">
          <div className="input-group-col">
            {props.questions &&
              props.questions.map((item, index) => (
                <div className={`py-2 border-bottom ${index === 0 ? "pt-0" : ""}`} key={index}>
                  <div className="input-group left has-validation">
                    <p className="my-auto w-25 text-dark">{t("validation.question")} {item.id}: </p>
                    <StringInput className="form-control" name="securityQues" value={item.question} readOnly />
                  </div>
                  <div className="input-group left has-validation">
                    <p className="my-auto w-25 text-dark">{t("validation.answer")}: </p>
                    <StringInput
                      // className={`${this.props.errorMsg.mobile_no && "was-validated is-invalid"}`}
                      className="form-control"
                      type="text"
                      placeholder={t("validation.insert-security-ans")}
                      name="securityAns"
                      defaultValue=""
                      value={props["confirmAns" + item.id]}
                      onChange={(e) => props.updateConfirmAns(e, item.id)}
                      // minLength={contact_no_min_limits}
                      // maxLength={contact_no_max_limits}
                      // minLengthMessage={t("validation.minLength", { 0: contact_no_min_limits })}
                      // maxLengthMessage={t("validation.maxLength", { 0: contact_no_max_limits })}
                      required
                      // requiredMessage={t("validation.required")}
                      // errorMsg={this.props.errorMsg.mobile_no || ""}
                      // formError={this.props.formError}
                    />
                  </div>
                </div>
              ))}
          </div>
        </div>

        <div className="px-3" style={{ marginTop: "-1rem" }}>
          <div className="text-danger d-flex align-items-start my-2">
            <span style={{ width: "0.75rem", height: "0.75rem" }}>
              <Icon className="me-1" icon="akar-icons:circle-alert-fill" />
            </span>
            <span>
            {t("validation.length-20")}
            </span>
          </div>
          <p className="notice-desc">
          {t("validation.tips-2")}
          </p>
        </div>
        <div className="mx-3 mb-3">
          <button className="btn btn-outline-blue w-100 mb-2" type="submit" onClick={props.backtoPrevStep}>
          {t("global.back")}
          </button>
          <button className="btn btn-gradient-blue w-100" type="submit" onClick={props.confirmationUpdateSetting}>
          {t("game-page.new")}
          </button>
        </div>
      </form>
    );
  };

  render() {
    const { t } = this.props;

    const steps = [
      { id: 1, label: "Security Check" },
      { id: 2, label: "Security Setting" },
      { id: 3, label: "Security Confirmation" },
    ];

    const questions = [
      { id: 1, question: t("security-question.question-1") },
      { id: 2, question: t("security-question.question-2") },
      { id: 3, question: t("security-question.question-3") },
      { id: 4, question: t("security-question.question-4") },
      { id: 5, question: t("security-question.question-5") },
    ];
    return (
      <section className="verification-m-section pf-m-dashboard on-top d-block pe-auto">
        <MobileSubHeader
          className="bg-white"
          closeModalHandler={this.props.backToPersonalDetails}
          header={t("validation.edit-sec-ans")}
          style={{ justifyContent: "unset" }}
        />

        <div className="step-progress-bar my-5 mx-3">
          {steps &&
            steps.map((item, index) => (
              <>
                <div
                  key={index}
                  className={`step ${
                    item.id < this.props.currentStep ? "completed" : item.id === this.props.currentStep ? "active" : ""
                  }`}
                >
                  {item.id < this.props.currentStep ? (
                    <p className="step-done">
                      <Icon icon="ic:baseline-check" />
                    </p>
                  ) : (
                    <p className="step-num">{item.id}</p>
                  )}
                  <p className="step-title">{item.label}</p>
                </div>

                {index + 1 !== steps.length && <hr className={`${item.id < this.props.currentStep && "active"}`} />}
              </>
            ))}
        </div>

        {this.props.currentStep === 1 ? (
          <this.stepSecurityCheck
            {...this.props}
            questions={questions}
            gotoNextStep={this.props.gotoNextStep}
            updateSecurityCheckAns={this.props.updateSecurityCheckAns}
            setSecurityQuestionHandler={this.props.setSecurityQuestionHandler}
            updateSecurityQuestionHandler={this.props.updateSecurityQuestionHandler}
          />
        ) : this.props.currentStep === 2 ? (
          <this.stepSecuritySetting
            {...this.props}
            gotoNextStep={this.props.gotoNextStep}
            updateNewSecurityQuestion={this.props.updateNewSecurityQuestion}
            updateNewSecurityAns={this.props.updateNewSecurityAns}
            updateSecuritySetting={this.props.updateSecuritySetting}
          />
        ) : this.props.currentStep === 3 ? (
          <this.stepSecurityConfirmation
            {...this.props}
            // newSecurityAns={this.state.newSecurityAns}
            questions={this.props.newSecuritySetting}
            gotoNextStep={this.props.gotoNextStep}
            backtoPrevStep={this.props.backtoPrevStep}
            updateConfirmAns={this.props.updateConfirmAns}
            confirmationUpdateSetting={this.props.confirmationUpdateSetting}
          />
        ) : (
          <></>
        )}
      </section>
    );
  }
}

export default withNamespaces()(SecurityAns);
